import { gql } from 'graphql-request'

export const ManyPageGroupsQuery = gql`
  # sort
  query AllPageGroups(
    $limit: Int! = 100,
    $page:Int! = 1,
    $locale: LocaleInputType!
  ) {
    PageGroups(
      limit: $limit,
      page: $page,
      locale: $locale
    ) {
      docs {
        id
        main {
          id
          title
          slug
        }
        levels {
          main {
            id
            title
            slug
          }
          children {
            id
            title
            slug
          }
        }
      }
      totalDocs
      limit
      totalPages
      page
      pagingCounter
      hasPrevPage
      hasNextPage
      prevPage
      nextPage
    }
  }
`
